// src/data/quotationData.js
import axios from "axios";

// Base URL for backend API calls
// const API_BASE = "http://103.251.218.254:91/api";
// const API_BASE = "http://192.168.1.248:3107";

// Helper: Convert a date string from "YYYY-MM-DD" to "DD/MM/YYYY" format.
const normalizeDate = (value) => {
    // Check if the value matches the ISO date pattern
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value.split("-").reverse().join("/");
    }
    // If not a valid ISO string, return as-is
    return value;
};

/**
 * Fetch and transform quotation data by ID
 * -----------------------------------------
 * @param {string|number} quotationId - The unique identifier for the quotation
 * @returns {Promise<Object>} - A structured object with master + detail rows, 
 *                              matching the shape expected by the UI
 */
const PurOrderData = async (quotationId, connectionString, companyId) => {
    try {
        // Build the endpoint URL using the base URL and the quotationId
        const url = `${connectionString}/api/get-purchase-order-data/${quotationId}`;

        // Fetch data from backend (expects { master, details } shape)
        const res = await axios.get(url);
        const { master, details } = res.data;
        console.log(res.data)

        let imageBase64 = '';
        try {
            console.log(`HARSH: ${connectionString}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
            const iconRes = await axios.get(`${connectionString}/api/company/GetIcon/${encodeURIComponent(companyId)}`);
            if (iconRes?.data?.success && iconRes.data.imageBase64) {
                console.log('Company logo fetched successfully');
                imageBase64 = iconRes.data.imageBase64;
            } else {
                console.warn('No logo returned from API');
            }
        } catch (iconErr) {
            console.warn('Failed to fetch company icon:', iconErr?.response?.data || iconErr.message);
        }

        // Transform each detail record to the UI's item schema
        const items = (details || []).map((d) => {
            // Parse numeric fields safely
            const rateNum = parseFloat(d.Rate) || 0;
            // Calculate CGST % based on tax amount vs rate
            const cgstPct = parseFloat(d.CGST) || 0;
            // SGST/IGST columns not provided by API, default to zero
            const sgstPct = parseFloat(d.SGST) || 0;
            const igstPct = parseFloat(d.IGST) || 0;
            const lineTotal = parseFloat(Number(d.Qty) * Number(d.Rate) * (1 - Number(d.Disc) / 100));

            return {
                hsnCode: d.HSNNo,      // Harmonized System Nomenclature code
                description: `${d.itemCode} - ${d.productDescription}`,   // Item description
                qty: d.Qty,                   // Quantity ordered
                rate: d.Rate,                 // Unit price
                Unit: d.Unit,
                discount: d.Disc,      // Discount amount on this line
                cgst: cgstPct,                // Calculated CGST percentage
                sgst: sgstPct,                // Default SGST percentage
                igst: igstPct,                // Default IGST percentage
                amount: lineTotal           // Total for this line after tax/discount
            };
        });

        // Build and return the master object using keys expected by the UI
        return {
            companyName: master.FirmName,                   // Client name
            address: master.Address || "",                  // Client address
            phone: master.MobileNo || "",                   // Client mobile number
            gstNo: master.GSTNo || "",                      // Client GSTIN
            invoiceNo: master.PONumber,                // Quotation number (UI calls it invoiceNo)
            referrenceNo: master.RefNo,             // Reference number
            date: master.PODate                        // Quotation date, normalized
                ? normalizeDate(master.PODate)
                : "",
            transport: master.Transporter || "SELF",         // Transport mode or default
            challanNo: master.lrNumber || "",               // LR/Challan number
            poNo: master.Project || "",                     // Purchase Order or project ref
            state: master.state || "",                      // Billing state
            stateCode: master.StateCode || "",              // Billing state code
            LrNo: master.lrNumber || "",                    // LR number (duplicate)
            vehNo: master.vehicleNumber || "",              // Vehicle number
            LrDate: master.lrDate                             // LR date, normalized
                ? normalizeDate(master.lrDate)
                : "",
            shipToGstNumber: master.shipToGstNumber || "",  // Shipping GSTIN
            shipToState: master.state || "",                // Shipping state
            items,                                            // Array of detailed line items
            toEmail: master.EmailId || "",                  // Recipient email
            totalAmount: master.grandTotal || 0,              // Grand total amount
            mobileNo: master.MobileNo || "",
            basicAmount: Number(master.BasicAmt) || 0,
            CGSTAmt: Number(master.CGSTAmt),
            SGSTAmt: Number(master.SGSTAmt),
            IGSTAmt: Number(master.IGSTAmt),
            RoundOff: Number(master.RoundOff),
            BillAmt: Number(master.BillAmt),
            clientState: master.clientState || '',
            clientStateCode: master.clientStateCode || '',
            imageBase64,
            // Client mobile number (duplicate)
        };
    } catch (err) {
        // Log and rethrow on errors
        console.error(`Error loading quotationData for id=${quotationId}`, err);
        throw err;
    }
};

export default PurOrderData;